module.exports = __webpack_public_path__ + "static/media/bronze.c6c6251b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bronze.svg
// module id = 1138
// module chunks = 0